import * as React from 'react'

import {
  ToggleGroup,
  ToggleGroupItem,
} from '~/client/src/shared/components/shadcn-ui/toggle-group'
import type ViewMode from '~/client/src/shared/components/ViewSelector/ViewMode'

export type IViewModeToggleOption = ViewMode

export interface IViewModeToggleProps {
  value: string
  modes: IViewModeToggleOption[]
  onChange: (mode: string) => void
  variant?: React.ComponentProps<typeof ToggleGroup>['variant']
  size?: React.ComponentProps<typeof ToggleGroup>['size']
  spacing?: number
}

const ViewModeToggle: React.FC<IViewModeToggleProps> = ({
  value,
  modes,
  onChange,
  variant = 'outline',
  size,
  spacing = 0,
}) => (
  <ToggleGroup
    variant={variant}
    size={size}
    spacing={spacing}
    value={[value]}
    onValueChange={([next]) => {
      if (next && next !== value) {
        onChange(next)
      }
    }}
  >
    {modes.map(({ mode, Icon, label, isDisabled }) => (
      <ToggleGroupItem
        key={mode}
        value={mode}
        aria-label={label ?? mode}
        disabled={isDisabled}
      >
        <Icon />
      </ToggleGroupItem>
    ))}
  </ToggleGroup>
)

export default ViewModeToggle
